import { render, staticRenderFns } from "./TabelaCalculos.vue?vue&type=template&id=627ec568&scoped=true&"
import script from "./TabelaCalculos.vue?vue&type=script&lang=js&"
export * from "./TabelaCalculos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaCalculos.vue?vue&type=style&index=0&id=627ec568&scoped=true&lang=css&"
import style1 from "./TabelaCalculos.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627ec568",
  null
  
)

export default component.exports